export default function getAriaString(labelItem, isMobile) {
    if (!labelItem)
        return undefined;
    if (typeof labelItem === "object") {
        var keyName = isMobile ? "mobile" : "general";
        return labelItem[keyName];
    }
    return labelItem;
}
